import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyADDbJcHlkgDK_gnC8Hm5CDIKoVQ9h-Wzc",
  authDomain: "ficsori-portal.firebaseapp.com",
  projectId: "ficsori-portal",
  storageBucket: "ficsori-portal.firebasestorage.app",
  messagingSenderId: "840836261974",
  appId: "1:840836261974:web:7d4f293d26894f5684b3f7",
  measurementId: "G-81K8W7LN9G"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore(app);
export const auth = getAuth(app);
export default app;
